import VueRouter, { RouteConfig } from 'vue-router';
import SignIn from './pages/SignIn.vue';
import SignInContinue from './pages/SignInContinue.vue';
import AccountDeletionRequested from './pages/AccountDeletionRequested.vue';
import PasswordNew from './pages/PasswordNew.vue';
import PasswordEdit from './pages/PasswordEdit.vue';
import MagicLinkNew from './pages/MagicLinkNew.vue';
import RequestAccess from './pages/RequestAccess.vue';
import ConfirmationNew from './pages/ConfirmationNew.vue';
import UnlockNew from './pages/UnlockNew.vue';
import GuestConfirmation from './pages/GuestConfirmation.vue';
import EventsAccess from './pages/EventsAccess.vue';
import UnsubscribeResult from './pages/UnsubscribeResult.vue';
import OAuthAuthorization from './pages/OAuthAuthorization.vue';

const routes: RouteConfig[] = [
  {
    path: '/users/sign_in',
    name: 'sign-in',
    component: SignIn,
  },
  {
    path: '/users/sign_in_continue',
    name: 'sign-in-continue',
    component: SignInContinue,
  },
  {
    path: '/users/account_deletion_requested',
    name: 'account-deletion-requested',
    component: AccountDeletionRequested,
  },
  {
    path: '/users/password/new',
    name: 'password-new',
    component: PasswordNew,
  },
  {
    path: '/users/password/edit',
    name: 'password-edit',
    component: PasswordEdit,
  },
  {
    path: '/users/magic_link/new',
    name: 'magic-link-new',
    component: MagicLinkNew,
  },
  {
    path: '/users/request',
    name: 'request-access',
    component: RequestAccess,
  },
  {
    path: '/users/confirmation/new',
    name: 'confirmation-new',
    component: ConfirmationNew,
  },
  {
    path: '/users/unlock/new',
    name: 'unlock-new',
    component: UnlockNew,
  },
  {
    path: '/users/guest/confirmation',
    name: 'guest-confirmation',
    component: GuestConfirmation,
  },
  {
    path: '/events/access',
    name: 'events-access',
    component: EventsAccess,
  },
  {
    path: '/unsubscribe/success',
    name: 'unsubscribe-success',
    component: UnsubscribeResult,
  },
  {
    path: '/unsubscribe/failed',
    name: 'unsubscribe-failed',
    component: UnsubscribeResult,
  },
  {
    path: '/oauth/authorize',
    name: 'oauth-authorization',
    component: OAuthAuthorization,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
